import { API } from "aws-amplify";
import { Auth } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";

import {
  getCourtOccupancySlotsQueryFn,
  getMemberOccupancySlotsQueryFn,
  getOccupancySlotsQueryFn,
  getRehabOccupancySlotsQueryFn,
  getNoShowOccupancySlotsQueryFn,
  getActivityOccupancySlotsQueryFn,
  getCoachOccupancySlotsQueryFn,
  exportStatisticsOccupancySlotsQueryFn,
  listStatisticsExportsQueryFn,
  deleteStatisticsExportQueryFn,
} from "./statisticsQueries";
import { OccupancyAggregationType } from "../../shared/enums";
import { MemberExportType } from "../../pages/AdminStatistics/AdminStatistics";

export const getOccupancySlots = async (
  start_date: string,
  end_date: string,
  types: OccupancyAggregationType[],
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    gender?: string;
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
    bookingStatuses?: string[];
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getOccupancySlotsQueryFn(
    start_date,
    end_date,
    types,
    "STANDARD",
    filters,
    selectedWeekdays,
  );

  const myQuery = `query myQuery(${inputs}) {
          ${query}  
    }`;

  try {
    const getChartResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getChartResponse.data.getOccupancySlots;
    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    if (response && !("message" in response) && "url" in response[0]) {
      const a = document.createElement("a");
      a.href = response[0].url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    return response;
  } catch (error: any) {
    toast.error(`${error.errors[0].message}`);
    return false;
  }
};

export const getRehabOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    permissionIds?: string[];
    gender?: string;
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getRehabOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
    selectedWeekdays,
  );

  const myQuery = `query myRehabQuery(${inputs}) {
          ${query}  
    }`;

  try {
    const getChartResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getChartResponse.data.getRehabOccupancySlots;
    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    return response;
  } catch (error: any) {
    toast.error(`${error.errors[0].message}`);
    return false;
  }
};

export const getCourtOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    gender?: string;
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
    bookingStatuses?: string[];
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getCourtOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
    selectedWeekdays,
  );
  const myQuery = `query myCourtQuery(${inputs}) {
          ${query}  
    }`;

  try {
    const getChartResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getChartResponse.data.getCourtOccupancySlots;
    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    return response;
  } catch (error: any) {
    toast.error(`${error.errors[0].message}`);
    return false;
  }
};

export const getMemberOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    gender?: string;
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
    bookingStatuses?: string[];
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getMemberOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
    selectedWeekdays,
  );
  const myQuery = `query myMemberQuery(${inputs}) {
          ${query}  
    }`;

  try {
    const getChartResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getChartResponse.data.getMemberOccupancySlots;
    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    return response;
  } catch (error: any) {
    toast.error(`${error.errors[0].message}`);
    return false;
  }
};

export const getNoShowOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    permissionIds?: string[];
    genders?: string[];
    ageRange?: { min?: number; max?: number };
  },
) => {
  const { query, variables, inputs } = getNoShowOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
  );

  const myQuery = `query myNoShowQuery(${inputs}) {
      ${query}
  }`;

  try {
    const res = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = res.data.getNoShowOccupancySlots;
    
    if ("message" in response[0]) {
      toast.error(response[0].message);
      return false;
    }

    return response;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return false;
  }
};

export const getActivityOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    genders?: string[];
    ageRange?: { min?: number; max?: number };
    timeRange?: { start_time?: string; end_time?: string };
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getActivityOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
    selectedWeekdays,
  );

  const myQuery = `query myActivityQuery(${inputs}) {
      ${query}
    }`;

  try {
    const gqlResponse = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = gqlResponse.data.getActivityOccupancySlots;

    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    return response;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return false;
  }
};

export const getCoachOccupancySlots = async (
  start_date: string,
  end_date: string,
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    genders?: string[];
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
    coachIds?: string[];
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = getCoachOccupancySlotsQueryFn(
    start_date,
    end_date,
    "STANDARD",
    filters,
    selectedWeekdays,
  );

  const myQuery = `query myCoachQuery(${inputs}) {
    ${query}
  }`;

  try {
    const gqlResponse = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = gqlResponse.data.getCoachOccupancySlots;

    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }

    return response;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return false;
  }
};

export const exportStatisticsOccupancySlots = async (
  export_resolver: string,
  exportType: OccupancyAggregationType | MemberExportType,
  startDate: string,
  endDate: string,
  fileName: string,
  filters?: {
    courtIds?: string[];
    permissionIds?: string[];
    genders?: string[];
    timeRange?: { start_time?: string; end_time?: string };
    ageRange?: { min?: number; max?: number };
    bookingStatuses?: string[];
    activityColors?: string[];
    coachIds?: string[];
  },
  selectedWeekdays?: number[],
) => {
  const { query, variables, inputs } = exportStatisticsOccupancySlotsQueryFn(
    export_resolver,
    exportType,
    startDate,
    endDate,
    fileName,
    filters,
    selectedWeekdays,
  );

  const myQuery = `query exportStats(${inputs}) {
    ${query}
  }`;

  try {
    const gqlResponse = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = gqlResponse.data.startOccupancyStatisticsExport;

    if (!response?.success) {
      toast.error(response?.message || "Export misslyckades");
      return false;
    }

    toast.success(
      "Export påbörjad. Det kan ta upp till en minut innan den visas under tabben 'Exporter'.",
    );
    return true;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return false;
  }
};

export const listStatisticsExports = async () => {
  const { query } = listStatisticsExportsQueryFn();
  const myQuery = `query listExports {
    ${query}
  }`;

  try {
    const gqlResponse = (await API.graphql({
      query: myQuery,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = gqlResponse.data.listStatisticsExports;

    if ("message" in response) {
      toast.error(`${response.message}`);
      return [];
    }

    return response;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return [];
  }
};

export const deleteStatisticsExport = async (export_id: string) => {
  const { query, inputs, variables } = deleteStatisticsExportQueryFn(export_id);

  const myQuery = `mutation deleteExport(${inputs}) {
    ${query}
  }`;

  try {
    const gqlResponse = (await API.graphql({
      query: myQuery,
      variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = gqlResponse.data.deleteStatisticsExport;

    if (!response?.success) {
      toast.error(response?.message || "Radering misslyckades");
      return false;
    }

    return true;
  } catch (error: any) {
    toast.error(error?.errors?.[0]?.message || "Unexpected error");
    return false;
  }
};
